import sky3 from './sky3'
import rebuild from './rebuild'
import product from './product'
import publish from './publish'
import node from './dayanNode'
import handle from './handle'

export default {
  namespaced: true,
  modules: {
    sky3,
    handle,
    rebuild,
    product,
    node,
    publish,
  },
}
